<p-toast key="centraltoast" position="bottom-right" styleClass="portal-toast" [preventOpenDuplicates]="true" />

<!-- Loading State -->
@if (isInitializing || sessionExpired) {
  <div class="loading-container">
    <div class="loading-content">
      <p-progressSpinner styleClass="w-4rem h-4rem" strokeWidth="3" animationDuration="1s"></p-progressSpinner>
      <p class="loading-text">
        {{ sessionExpired ? 'Sitzung abgelaufen, leite dich zum Login weiter...' : 'Initialisiere Anwendung...' }}
      </p>
    </div>
  </div>
}

@if (!isInitializing && !sessionExpired && isTenantSwitched && !isOnboarding && !isConsent && !isInstanceAdmin) {
  <app-configuration></app-configuration>
}

@if (!isInitializing && !sessionExpired && isOnboarding && isTenantSwitched) {
  <router-outlet></router-outlet>
}

@if (!isInitializing && !sessionExpired && isInstanceAdmin) {
  <app-shell></app-shell>
}

@if (!isInitializing && !sessionExpired && isConsent) {
  <router-outlet></router-outlet>
}

@if (!isInitializing && !sessionExpired && !isTenantSwitched) {
  <app-tenant-selection
    [connectedTenants]="connectedTenants"
    [selectedTenantId]="selectedTenantId"
    (tenantSelected)="selectTenant($event)"
  ></app-tenant-selection>
}
